// HeaderJS config
// Het paneel-menu werkt op elke breedte: een breakpoint dat nooit bereikt wordt houdt de parent in de mobiele (paneel)modus.
window.pkHeaderData = { responsiveBreakpoint: 99999 };

import '@pk-theme/header.js';
import '@pk-theme/dialogs.js';